module.exports = __webpack_public_path__ + "static/media/rogue5_preview.989b6485.jpg";